import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return {
      filters: { type: Object, default: {} },
      numberOfLeads: { type: Number, default: 0 },
      selectedLeadIds: { type: Array, default: [] },
    }
  }

  submit() {
    const params = new URLSearchParams()

    if (this.selectedLeadIdsValue.length > 0) {
      // Use selected lead IDs
      this.selectedLeadIdsValue.forEach(leadId => {
        params.append("lead_ids[]", leadId)
      })
    } else {
      // Use current filters
      Object.entries(this.filtersValue).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          params.append(key, value)
        }
      })
    }

    // Get the lookalikes path
    const lookalikesUrl = `/leads/lookalikes?${params.toString()}`

    // Set the turbo frame src and open sidepanel
    const turboFrame = document.querySelector("turbo-frame#leads_sidepanel")
    if (turboFrame) {
      // Set the src which will trigger the load
      turboFrame.src = lookalikesUrl

      // Open the sidepanel by triggering the side-panel controller
      const sidePanelElement = document.querySelector("[data-side-panel-target='sidePanel']")
      if (sidePanelElement) {
        sidePanelElement.setAttribute("aria-hidden", "false")
      }

      // Also trigger overlay if needed
      const overlayElement = document.querySelector("[data-side-panel-target='overlay']")
      if (overlayElement) {
        overlayElement.classList.remove("invisible")
        overlayElement.classList.add("is-visible")
      }
    }
  }

  // This function is triggered using stimulus actions to update the selected leads value.
  updateSelection(event) {
    if (event.detail.allSelected) {
      this.selectedLeadIdsValue = []
    } else if (event.detail.dataSets) {
      this.selectedLeadIdsValue = event.detail.dataSets.map(dataSet => dataSet.leadId || dataSet.recordId).filter(Boolean)
    } else {
      this.selectedLeadIdsValue = []
    }
  }
}
